import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { JSEncrypt } from 'jsencrypt';

import { Button, OTP, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../../context/GlobalContext';

import { promotionQualification, resendOTP, subsidyEligibilityCheck, validateOTP, installmentPackageEligibility, installmentCustomerEligibility, cemValidateOTP, getAccountByNumber, cemResendOTP } from '../../../api/api';
import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';

import './DeviceOTP.scss';
import ErrorModal from '../../ErrorModal/ErrorModal';

interface Props {
    timer: number;
    setTimer: (value: any) => void;
    handleHeaderCancel: () => void;
}

const win: any = window;
const serverURL = win['base_portal_url'];
const errorPage = win['errorPageURL'];

function DeviceOTP({ handleHeaderCancel, setTimer, timer }: Props) {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, msisdn, OTPData, scData, cartId, productId, encryptedMSISDN, productData, deviceFlow, customerAccount, graphQlResponse } = state;
    const { preOrder } = productData
    const { t } = useTranslation();
    const uniqueProductNameArr = graphQlResponse?.getProductOfferByID[0]?.specCharValueUse.filter((val: any) => (val.name === 'Unique Technical Name'))[0];
    const uniqueProductName = uniqueProductNameArr?.specCharacteristicValue[0]?.value ? uniqueProductNameArr?.specCharacteristicValue[0]?.value : "";

    const [otpValue, setotpValue] = useState('');
    const [showOTPError, setShowOTPError] = useState(false);
    const [notEligible, setNotEligible] = useState(false);
    const [notCustomer, setNotCustomer] = useState(false);
    const cemPublicKey = win['cem_public_key'];
    const jsencrypt = new JSEncrypt();
    jsencrypt.setPublicKey(cemPublicKey);
    const bmClientId = win['BM_CI'];
    const bmClientSecret = win['BM_CS'];
    
    const refId = OTPData?.data?.refId ? OTPData?.data?.refId : "";

    useEffect(() => {
        let countdown: any;
        const countdownFunction = () => {
            countdown = setInterval(() => {
                setTimer((prevTimer: any) => {
                    if (prevTimer > 0) {
                        return prevTimer - 1;
                    } else {
                        clearInterval(countdown);
                        return 0;
                    }
                });
            }, 1000);
        }
        countdownFunction();

        return () => clearInterval(countdown);
    }, [timer]);

    const formatTime = (time: any) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
    };

    const handleOTPChange = (otp: any) => {
        setotpValue(otp);

        if (otp.length === 4) {
            dispatch({ type: "LOADER", payload: { loading: true } });
            dispatch({ type: "CAPTURE_OTP_VALUE", payload: { otpValue: otp } });
            // validateOTPAPI(otp);
            cemValidateOTPAPI(otp)
        }
    }

    const handleNotCustomer = () => {
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceLogin' } });
        setNotCustomer(false);
        // childRef?.current?.removeMobileNumber();
    }

    // const validateOTPAPI = (otp: any) => {
    //     const { ServiceRequestID } = OTPData;
    //     const req = { ServiceRequestID, encryptedMSISDN, otp, cartId };

    //     validateOTP(req, preOrder)
    //         .then((res: any) => {
    //             if (res.status === 200) {
    //                 if (deviceFlow === "subsidy") {
    //                     eligbilityCheckAPI();
    //                 } else {
    //                     installmentEligbilityCheckAPI();
    //                 }
    //             } else if (res?.status === 500) {
    //                 if (res?.data?.ErrorCode === "CEM_VOTP_002" || res?.data?.ErrorCode === "CEM_VOTP_003") {
    //                     setTimer(0);
    //                     setotpValue('');
    //                     setShowOTPError(true);
    //                     dispatch({ type: "LOADER", payload: { loading: false } });
    //                 } else if (res?.data?.ErrorCode === "CEM_VOTP_001") {
    //                     window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
    //                 } else {
    //                     window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
    //                 }

    //             } else if (res?.status === 404) {
    //                 if (res?.data?.status == 'false') {
    //                     setTimer(0);
    //                     setotpValue('');
    //                     setShowOTPError(true);
    //                     dispatch({ type: "LOADER", payload: { loading: false } });
    //                 } else {
    //                     window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
    //                 }

    //             } else {
    //                 window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
    //             }
    //         })
    // }

    const cemValidateOTPAPI = (otp: any) => {
    const EnBmClientId = bmClientId? jsencrypt.encrypt(bmClientId) : "";
    const EnBmClientSecret = bmClientSecret ? jsencrypt.encrypt(bmClientSecret) : "";
        const req = { otp, refId, EnBmClientId, EnBmClientSecret };

        cemValidateOTP(req)
            .then((res: any) => {
                if (res.status === 200) {
                    if(res?.data?.status?.sourceCode === "MAPI-000") {
                        const pNumber = msisdn.length > 0 ? msisdn.replace('0', '966') : '';
                        const accessToken = res?.data?.data?.access_token;
                        getAccountByNumberApi(pNumber, accessToken);
                        // if (deviceFlow === "subsidy") {
                        //     eligbilityCheckAPI();
                        // } else {
                        //     installmentEligbilityCheckAPI();
                        // }
                    } else {
                        window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                    }
                } else if (res?.status === 401) {
                    if (res?.data?.status?.sourceCode === "MAPI-401-8") {
                        setTimer(0);
                        setotpValue('');
                        setShowOTPError(true);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                    } else {
                        window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                    }

                } else {
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }

    const getAccountByNumberApi = (msisdn: string, accessToken: any) => {
        getAccountByNumber(msisdn, preOrder, accessToken)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    if (res.data?.MSISDN) {
                         if (deviceFlow === "subsidy") {
                            eligbilityCheckAPI();
                        } else {
                            installmentEligbilityCheckAPI(res?.data);
                        }
                        dispatch({ type: 'CUSTOMER_ACCOUNT_BY_NUMBER', payload: { customerAccount: res?.data } })
                    } else {
                        setNotCustomer(true);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                    }
                } else {
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }

    const eligbilityCheckAPI = () => {
        const req = {
            msisdn: msisdn.replace('0', '966'),
            packageId: productId
        }

        subsidyEligibilityCheck(req)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    if (res.data.status.code === 'CEM_0000') {
                        setNotEligible(false);
                        let promotionType = '';

                        if (res.data.eligibleRaqiPromotions.length > 0) {
                            promotionType = 'Raqi';
                            dispatch({ type: 'RAQI_PROMOTION', payload: { raqiPromotion: res.data.eligibleRaqiPromotions, promotionType: 'Raqi' } })
                        }

                        if (res.data.eligibleWajidPromotions.length > 0) {
                            promotionType = 'Wajid';
                            dispatch({ type: 'WAJID_PROMOTION', payload: { wajidPromotion: res.data.eligibleWajidPromotions, promotionType: 'Wajid' } })
                        }


                        if (res.data.eligibleRaqiPromotions.length > 0 || res.data.eligibleWajidPromotions.length > 0) {
                            promotionQualificationAPI(promotionType)
                        }

                    } else {
                        setNotEligible(true);
                        dispatch({ type: "LOADER", payload: { loading: false } });
                    }
                } else {
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }
    const installmentEligbilityCheckAPI = (customerInquiry: any) => {
        const sanNum = customerInquiry?.ServiceAccountNumber ? customerInquiry?.ServiceAccountNumber : '';
        const req = {
            msisdn: msisdn.replace('0', '966'),
            packageId: uniqueProductName,
            san: sanNum
        }

        installmentPackageEligibility(req)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    if (res?.data?.status?.code === "CEM_0000") {
                        const whitelistFlag = res.data?.whitelistFlag ? res.data?.whitelistFlag : "";
                        const blacklistFlag = res.data?.blacklistFlag ? res.data?.blacklistFlag : "";
                        const plans = res.data?.deviceInstallmentPromotions ? res.data?.deviceInstallmentPromotions : [];
                        if ((plans?.length >= 1) && (whitelistFlag === "Y" || blacklistFlag === "N")) {
                            dispatch({ type: "INSTALMENT_PACKAGE_ELIGIBILITY", payload: { packageEligibility: res?.data } });
                            dispatch({ type: "LOADER", payload: { loading: false } });
                            dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceClaimPlan' } });
                        } else {
                            dispatch({ type: "LOADER", payload: { loading: false } });
                            setNotEligible(true);
                        }
                    } else {
                        window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                    }
                } else {
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }

    const promotionQualificationAPI = (promotionType: string) => {
        promotionQualification(scData, promotionType)
            .then((res: any) => {
                if (res.status === 200 && res.data) {
                    const promotiondata = res.data?.cart?.offerContainer[0]?.offerContainerItem[0]?.promotions?.default;

                    dispatch({ type: "LOADER", payload: { loading: false } });
                    dispatch({ type: "PROMOTIONS_DATA", payload: { promotionData: promotiondata } });
                    dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: 'deviceClaimPlan' } });
                } else {
                    dispatch({ type: "LOADER", payload: { loading: false } });
                    window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
                }
            }).catch(err => {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            })
    }


    const handleResend = () => {
        // const { OrderId, ServiceRequestID, } = OTPData;
        dispatch({ type: "LOADER", payload: { loading: true } })

        // const req = {
        //     OrderId, ServiceRequestID, cartId
        // }

        // resendOTP(req, preOrder)
        //     .then((res: any) => {
        //         if (res?.status === 200) {
        //             if (res?.data?.Status) {
        //                 setotpValue('');
        //                 dispatch({ type: "LOADER", payload: { loading: false } })
        //                 setTimer(res?.data?.OTPExpiry);
        //                 setShowOTPError(false);
        //             } else {
        //                 window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
        //             }
        //         } else {
        //             window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
        //         }
        //     })

        cemResendOTP(refId)
        .then((res: any) => {
            if (res?.status === 204) {
                    setotpValue('');
                    dispatch({ type: "LOADER", payload: { loading: false } })
                    setTimer(120);
                    setShowOTPError(false);
            } else {
                window.location.href = serverURL + errorPage + `?errorSource= ${t("ecommerce")}`;
            }
        })
    }

    const handleBackArrow = () => {
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceLogin" } })
    }

    const handleNotEliglible = () => {
        setNotEligible(false);
        dispatch({ type: 'SUB_PAGE_TO_DISPLAY', payload: { subPageToDisplay: "deviceLogin" } })
    }

    return (
        <>
            <HeaderNavigation
                rtl={rtl}
                percent={50}
                showBackArrow={true}
                handleBackArrow={handleBackArrow}
                handleHeaderCancel={handleHeaderCancel}
            />
            <div className='Verify__Container'>
                <div className='SL__headerText'>
                    <Typography rtl={rtl} id="verify-heading" className='SL__heading'>{t('Verify_heading')}</Typography>
                    <Typography rtl={rtl} id="verify-Subheading" className='SL__subHeading'>
                        {t('Verify_Subheading')}
                        <div className='Verify__Msisdn'>{msisdn}.</div>
                        <div>{t('Verify_ToContinue')}</div>
                    </Typography>
                </div>

                <div className='Verify__OTP'>
                    <OTP id="otp-input" rtl={rtl} numInputs={4} onChange={handleOTPChange} value={otpValue} />
                    {timer > 0 ? (
                        <Typography id="resend-code" rtl={rtl} className='Verify__timer'>
                            {t('Verify_ResendNewCode')} <span>{formatTime(timer)}</span>
                        </Typography>
                    ) : showOTPError ? (
                        <Typography className='Verify__otpError' rtl={rtl}>
                            {t("code_not_valid")}
                            <span id='resend-otp' className='Verify__sendAgain_error' onClick={handleResend}>
                                {t("Send_again")}
                            </span>
                        </Typography>
                    ) : (
                        <Typography className='Verify__Resend' rtl={rtl}>
                            {t("Didnt_receive_the_code")}
                            <span id='resend-otp' className='Verify__sendAgain' onClick={handleResend}>
                                {t("Send_again")}
                            </span>
                        </Typography>
                    )}
                </div>


                {notEligible && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={deviceFlow === 'subsidy' ? t('Plan_not_eligible') : t('installment_plan_not_eligible')}
                        description={deviceFlow === 'subsidy' ? t('Number_not_eligible') : t('installment_Number_not_eligible')}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleNotEliglible}
                    />
                )}

                {notCustomer && (
                    <ErrorModal
                        id={'not-a-mobily-number'}
                        rtl={rtl}
                        title={t('Not_a_mobily_number')}
                        description={t('we_didnot_recognize_number')}
                        firstButtonText={t('Got_it')}
                        modalFirstButtonClick={handleNotCustomer}
                    />
                )}

                {/* <Button
                    rtl={rtl}
                    id="login-button"
                    className="Verify__Btn"
                    variant={otpValue.length === 4 ? "default" : "disabled"}
                    onClick={handleOTPSubmit}
                >
                    {'Continue'}
                </Button> */}
            </div>
        </>
    )
}

export default DeviceOTP